<template>
  <div class="content">
    <h2 class="text-2xl font-bold mb-4">Business Usage</h2>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Can I use the wheel for business purposes?</h3>
      <p>Yes, Spin the Names is suitable for various business applications. Many companies use the wheel for:</p>
      <ul class="list-disc ml-6 mt-2">
        <li>Team building activities</li>
        <li>Selecting random winners for promotional giveaways</li>
        <li>Making fair selections during meetings</li>
        <li>Training exercises and interactive presentations</li>
        <li>Event engagement and audience participation</li>
        <li>Decision making when multiple options are equally viable</li>
      </ul>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Are there premium features for businesses?</h3>
      <p>Currently, all features are available to all users, including businesses. Spin the Names provides equal
        access to all functionality regardless of whether it's used for personal or professional purposes. If you
        have specific business needs that aren't met by the current version, feel free to contact
        ash@spinthenames.com.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Can I use the wheel for promotional contests?</h3>
      <p>Yes, many businesses use Spin the Names for promotional activities. When using the wheel for contests or
        giveaways:</p>
      <ul class="list-disc ml-6 mt-2">
        <li>Ensure you comply with all applicable laws regarding contests and promotions</li>
        <li>Consider using the sharing feature to maintain transparency</li>
        <li>Save your wheel configuration to document the selection process</li>
        <li>Use the customization options to brand the wheel with your company colors</li>
      </ul>
      <p class="mt-2">Note that you are solely responsible for ensuring your contests comply with relevant laws
        and regulations.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Can I embed the wheel on my business website?</h3>
      <p>Yes, you can embed Spin the Names on your website. This is particularly useful for interactive campaigns,
        promotional pages, or engaging content on your site. See the "Embedding" section for more details on embedding
        options.</p>
    </div>

    <p class="mt-8 text-sm"><a href="#top" class="text-blue-500 hover:underline">Back to top</a></p>
  </div>
</template>

<script setup>
import '@components/ui/faq/faqStyles.css';
</script>
